import React from "react";

import { templates } from "@reactivated";

import { UGCCarousel } from "../components/UGCCarousel";
import { UGCListSubBlock } from "../models/ugc";

interface IUGCCarouselBlockData {
    posts: UGCListSubBlock[];
}

export const Template = (
    props: templates.UGCCarouselTemplate,
): React.JSX.Element => {
    const blockData: IUGCCarouselBlockData | null = (() => {
        try {
            return JSON.parse(props.block_data) as IUGCCarouselBlockData;
        } catch {
            return null;
        }
    })();

    return (
        <div className="ugc-carousel-container l-full-width">
            <div className="ugc-carousel l-capped-width">
                {props.desc && (
                    <section
                        className="ugc-carousel__header"
                        dangerouslySetInnerHTML={{ __html: props.desc }}
                    />
                )}
                <UGCCarousel tiles={blockData?.posts} />
            </div>
        </div>
    );
};
